// Regular Commission — a second prestige above ORD (Antimatter nested resets;
// AdVenture Capitalist angel upgrades; Cookie Clicker ascension tree). Signing
// on as a Regular wipes Commendations for Command Points, spent in a permanent
// tree that makes every later run faster and unlocks new verbs.
export const COMMISSION_UNLOCK_COMMENDATIONS = 100;

// sqrt curve like ORD, but rarer — Command Points come slowly. Commendations
// are wiped on commission, so (unlike ORD) there is no held total to subtract.
export function commandPointGain(commendations) {
  return Math.max(0, Math.floor(Math.sqrt(Math.max(0, commendations) / 25)));
}

export const COMMISSION_UPGRADES = [
  { id: 'seed-credits', name: 'War Chest', detail: 'Start each enlistment with 10,000 Credits.', cost: 1 },
  { id: 'output-1', name: 'Standing Doctrine I', detail: '+25% global output.', cost: 2, mult: 1.25 },
  { id: 'output-2', name: 'Standing Doctrine II', detail: '+50% global output.', cost: 5, mult: 1.5, requires: 'output-1' },
  { id: 'commons-fast', name: 'Forward Depots', detail: 'Commons accrue twice as fast.', cost: 3 },
  { id: 'auto-early', name: 'Standing Orders', detail: 'Automation unlocks from rank 1.', cost: 3 },
  { id: 'offline-plus', name: 'Reservist Network', detail: 'Offline rate rises to 75%.', cost: 4 },
  { id: 'tempo-cheap', name: 'Efficient Tempo', detail: 'Operational Tempo costs 60% less.', cost: 4 },
  { id: 'auto-ord', name: 'Career Track', detail: 'Auto-ORD as soon as Commendations are available.', cost: 6, requires: 'output-2' },
];

export function commissionMult(upgrades = []) {
  let mult = 1;
  for (const upgrade of COMMISSION_UPGRADES) {
    if (upgrade.mult && upgrades.includes(upgrade.id)) mult *= upgrade.mult;
  }
  return mult;
}

export function commissionFor(id) { return COMMISSION_UPGRADES.find((upgrade) => upgrade.id === id); }
